module.exports = __webpack_public_path__ + "img/1-9.9430bb5c.svg";